import { useState } from "react";
import DashboardLayout from "../../../shared/DashboardLayout";

const HousePlans = () => {
  // State for form fields
  const [formData, setFormData] = useState({
    bf_amount: "",
    bf_downpayment: "",
    bf_monthly: "",
    bf_number_of_installments: "",
    bf_possesion: "",
    bf_registery: "",
    bf_yearly: "",
    bf_front: "",
    bf_house_block: "",
    bf_house_size: "",
    bf_plan_name: "",
  });

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <DashboardLayout>
      <h2 className="m-4">House Plans</h2>
      <div className="row m-4">
        <div className="col-lg-4">
          <label htmlFor="bf_amount" className="form-label fw-bolder">
            House Total Price <span className="required">*</span>
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <input
            type="number"
            className="form-control"
            name="bf_amount"
            id="bf_amount"
            value={formData.bf_amount}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-lg-4">
          <label htmlFor="bf_downpayment" className="form-label fw-bolder">
            Down Payment <span className="required">*</span>
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <input
            type="number"
            className="form-control"
            name="bf_downpayment"
            id="bf_downpayment"
            value={formData.bf_downpayment}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-lg-4">
          <label htmlFor="bf_monthly" className="form-label fw-bolder">
            Monthly <span className="required">*</span>
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <input
            type="number"
            className="form-control"
            name="bf_monthly"
            id="bf_monthly"
            value={formData.bf_monthly}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-lg-4">
          <label
            htmlFor="bf_number_of_installments"
            className="form-label fw-bolder"
          >
            Total Installments <span className="required">*</span>
          </label>
          <p className="fst-italic">Number of installments</p>
        </div>
        <div className="col-lg-8 form-group">
          <input
            type="number"
            className="form-control"
            name="bf_number_of_installments"
            id="bf_number_of_installments"
            value={formData.bf_number_of_installments}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-lg-4">
          <label htmlFor="bf_possesion" className="form-label fw-bolder">
            Possession <span className="required">*</span>
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <input
            type="number"
            className="form-control"
            name="bf_possesion"
            id="bf_possesion"
            value={formData.bf_possesion}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-lg-4">
          <label htmlFor="bf_registery" className="form-label fw-bolder">
            Registry <span className="required">*</span>
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <input
            type="number"
            className="form-control"
            name="bf_registery"
            id="bf_registery"
            value={formData.bf_registery}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-lg-4">
          <label htmlFor="bf_yearly" className="form-label fw-bolder">
            Yearly <span className="required">*</span>
          </label>
          <p className="fst-italic">Each Year Installment Price</p>
        </div>
        <div className="col-lg-8 form-group">
          <input
            type="number"
            className="form-control"
            name="bf_yearly"
            id="bf_yearly"
            value={formData.bf_yearly}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-lg-4">
          <label htmlFor="bf_front" className="form-label fw-bolder">
            Front <span className="required">*</span>
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <input
            type="number"
            className="form-control"
            name="bf_front"
            id="bf_front"
            value={formData.bf_front}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-lg-4">
          <label htmlFor="bf_house_block" className="form-label fw-bolder">
            Block
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <select
            name="bf_house_block"
            id="bf_house_block"
            className="form-control"
            value={formData.bf_house_block}
            onChange={handleChange}
          >
            <option value="" selected="selected">
              -- Select --
            </option>
            <option value="a">A Block</option>
            <option value="b">B Block</option>
            <option value="c">C Block</option>
            <option value="d">D Block</option>
            <option value="e">E Block</option>
          </select>
        </div>
        <div className="col-lg-4">
          <label htmlFor="bf_house_size" className="form-label fw-bolder">
            House Size
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <select
            name="bf_house_size"
            id="bf_house_size"
            className="form-control"
            value={formData.bf_house_size}
            onChange={handleChange}
          >
            <option value="" selected="selected">
              -- Select --
            </option>
            <option value="1">1 Marla</option>
            <option value="1.5">1.5 Marla</option>
            <option value="2">2 Marla</option>
            <option value="2.5">2.5 Marla</option>
            <option value="3">3 Marla</option>
            <option value="3.5">3.5 Marla</option>
            <option value="4">4 Marla</option>
            <option value="4.5">4.5 Marla</option>
            <option value="5">5 Marla</option>
          </select>
        </div>
        <div className="col-lg-4">
          <label htmlFor="bf_plan_name" className="form-label fw-bolder">
            Plan Name <span className="required">*</span>
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <input
            type="text"
            className="form-control"
            name="bf_plan_name"
            id="bf_plan_name"
            value={formData.bf_plan_name}
            onChange={handleChange}
          />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default HousePlans;
